import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=41485163&"
import script from "./AppointmentDetails.ts?vue&type=script&lang=ts&"
export * from "./AppointmentDetails.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports